import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/nfse/trasnferirEscrituracao/';

class TransferirEscrituracaoService {
    constructor() {
        this.idCliente = null;
        this.idContribuinte = null;
        this.idNfsPessoa = null;
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    listAllFiltroPesquisar(filtro, numero, dataIni, dataFin, tipoEmissao) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.get(API_URL + 'consulta?idCliente=' + this.idCliente
                                 + '&filtro=' + filtro
                                 + '&numero=' + numero
                                 + (dataIni ? ('&dataIni=' + dataIni) : "")
                                 + (dataFin ? ('&dataFin=' + dataFin) : "")
                                 + '&tipoEmissao=' + tipoEmissao,
                                 {headers: this.headers}).then(response => (this.data = response.data.elements));
    }

    gravar(idUsuario, idPessoa, documentos) {
        return axios.post(API_URL + 'gravar?idUsuario=' + idUsuario
                                 + '&idPessoa=' + idPessoa, JSON.stringify(documentos),
                                 {headers: this.headers});
    }

}

export default new TransferirEscrituracaoService();